<prism-progress-dots id="sh-loader-progress-dots"></prism-progress-dots>
